export default "__VITE_ASSET__CCGrajp___"